// extracted by mini-css-extract-plugin
module.exports = {"container":"ModelDetailsTable-module__container--3esQ3","textLeft":"ModelDetailsTable-module__textLeft--3nOp6","dateText":"ModelDetailsTable-module__dateText--1rvm8"};